import { render, staticRenderFns } from "./LoginFormAuth.vue?vue&type=template&id=263520b1"
import script from "./LoginFormAuth.vue?vue&type=script&lang=js"
export * from "./LoginFormAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports